/**
 * DEV-ONLY seed tasks (CT-5093) — TEMPORARY.
 *
 * TODO(CT-5159): delete this file and its four call sites (WorkQueueProvider,
 * useTeamActions, mapSourceToEvent, workQueue) — the `__seed` marker currently
 * branches inside production network-skip paths. Move the seed to the boundary
 * (taskUuid:null rows) once the tenant has real open tasks.
 *
 * The tenant currently has 0 real tasks, so the interim `task` event never
 * renders and the graphical layer (detail body + Resolve footer + Take / Reassign
 * / Skip menu) can't be seen in the running UI. This seeds contract-shaped tasks
 * (exactly the shape POST /v1/task/my-work/list returns per the CT-4854 Tasks API
 * contract) so that layer can be verified and captured.
 *
 * Gated to `import.meta.env.DEV` AND an explicit localStorage flag, so it NEVER
 * reaches production and never appears in a normal dev session unless asked for.
 *
 *   Enable :  localStorage.setItem('wq_seed_task', '1')   // then reload
 *   Disable:  localStorage.removeItem('wq_seed_task')
 *
 * `__seed: true` marks these so the action handlers skip the network (a fake uuid
 * would 404) and show a clean optimistic success. DELETE this file (and its two
 * call sites) once real tasks exist in the tenant.
 */

/** True only in a dev build with the explicit opt-in flag set. */
function seedEnabled() {
  if (!import.meta.env.DEV) return false;
  try {
    return localStorage.getItem('wq_seed_task') === '1';
  } catch {
    return false;
  }
}

/** The logged-in user's uuid so the seed task is owned by "me" (Take/My Work). */
function currentUserUuid() {
  try {
    return localStorage.getItem('user_uuid') || 'seed-user-00000000-0000-0000-0000-000000000000';
  } catch {
    return 'seed-user-00000000-0000-0000-0000-000000000000';
  }
}

/**
 * Contract-shaped raw tasks, or `[]` when the seed is not enabled. Appended to the
 * live my-work/list result in the fan-out; they flow through the same mappers as a
 * real task, so what renders is exactly what a real task would render.
 */
export function getDevSeedTasks() {
  if (!seedEnabled()) return [];
  const me = currentUserUuid();
  const ts = new Date().toISOString();
  return [
    {
      __seed: true,
      taskUuid: 'seed-task-11111111-1111-1111-1111-111111111111',
      entityType: 'change_request',
      entityUuid: 'seed-cr-22222222-2222-2222-2222-222222222222',
      assigneeUuid: me,
      status: 'open',
      severity: 'High',
      reason: 'Review source before publish',
      message: 'Please confirm the source document before this change request is published.',
      createdByUuid: 'seed-actor-33333333-3333-3333-3333-333333333333',
      createdAt: ts,
      updatedAt: ts,
    },
    {
      __seed: true,
      taskUuid: 'seed-task-44444444-4444-4444-4444-444444444444',
      entityType: 'claim',
      entityUuid: 'seed-claim-55555555-5555-5555-5555-555555555555',
      assigneeUuid: me,
      status: 'open',
      severity: 'Critical',
      reason: 'Conflicting evidence',
      message: 'Two sources disagree on this claim — needs an expert decision.',
      createdByUuid: 'seed-actor-33333333-3333-3333-3333-333333333333',
      createdAt: ts,
      updatedAt: ts,
    },
  ];
}
